<template>
  <div>
    <v-card flat class="pa-6 instructions__section">
      <div class="d-flex pb-4">
        <v-text-field backgroundColor="white" outlined label="Rubrik" v-model="section.header"></v-text-field>
        <v-btn :disabled="index === 0" class="icon mt-2 ml-4" color="secondary" @click="$emit('moveUp')">
          <v-icon>$sl-arrow-up</v-icon>FLYTTA UPP</v-btn
        >
        <v-btn
          :disabled="index === total - 1"
          class="icon mt-2 ml-4"
          color="secondary"
          large
          @click="$emit('moveDown')"
        >
          <v-icon>$sl-arrow-down</v-icon>FLYTTA NED</v-btn
        >
      </div>
      <v-textarea backgroundColor="white" label="Text" outlined rows="4" v-model="section.text"></v-textarea>
      <p class="pb-4">
        Webbadresser som börjar på http eller https visas automatiskt som länkar. Använd asterisker (*) för att göra
        text <i>*kursiv*</i> eller <b>**fet**</b>. Använd bindestreck (-) i början av en rad för att skapa punktlistor.
      </p>
      <v-textarea backgroundColor="white" label="Kvittering" outlined rows="4" v-model="section.checks"></v-textarea>
      <p class="bold">
        <v-icon class="mr-2">$sl-info</v-icon>Varje rad ovan blir en egen checkruta för kvittering av avsnittet i
        handledarinstruktionerna på Mina sidor.
      </p>
      <v-btn class="icon" color="secondary" @click="$emit('delete')"> <v-icon>$sl-delete</v-icon>TA BORT AVSNITT</v-btn>
    </v-card>
    <div class="py-4 d-flex justify-end">
      <v-btn class="icon" color="secondary" @click="$emit('add')"> <v-icon>$sl-add</v-icon>LÄGG TILL AVSNITT HÄR</v-btn>
    </div>
  </div>
</template>

<script>
import {RulesMixin} from '@/components/mixins'

export default {
  name: 'InsturctionSection',

  props: {
    section: {},
    index: 0,
    total: 0
  },

  data: () => ({}),
  mixins: [RulesMixin],

  methods: {}
}
</script>

<style lang="scss" scoped>
</style>